import { motion, useReducedMotion } from 'framer-motion';

export function AchievementBadge({
  label,
  value,
  tone = 'gold',
}: {
  label: string;
  value: string;
  tone?: 'gold' | 'success' | 'ai';
}) {
  const reduceMotion = useReducedMotion();
  const bg =
    tone === 'gold'
      ? 'from-amber-500/20 to-orange-500/10 border-amber-400/25'
      : tone === 'ai'
        ? 'from-violet-500/20 to-fuchsia-500/10 border-violet-400/25'
        : 'from-emerald-500/20 to-teal-500/10 border-emerald-400/25';

  return (
    <motion.div
      initial={reduceMotion ? {} : { scale: 0.92, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`rounded-xl border bg-gradient-to-br px-3 py-2.5 ${bg}`}
    >
      <div className="text-[10px] font-semibold uppercase tracking-wide text-zinc-400">{label}</div>
      <div className="mt-0.5 font-display text-sm font-bold text-white">{value}</div>
    </motion.div>
  );
}
